import { render, staticRenderFns } from "./TopUpAccountDialog.vue?vue&type=template&id=83a86172&scoped=true&"
import script from "./TopUpAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./TopUpAccountDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a86172",
  null
  
)

export default component.exports